import Marionette from "backbone.marionette";

import { heapTrack } from "lib/analytics";

import authHandleTemplate from "../../templates/components/auth/auth-handle.jst";
import util from "../../util";

const UserHandleComponent = Marionette.View.extend({
    template: authHandleTemplate,

    ui: {
        error: ".error",
        handle: "#handle",
        nextBtn: "#btn-next",
    },

    events: {
        "click @ui.nextBtn": "next",
    },

    serializeData() {
        const { phone, email, loginHandle } = this.options;
        let handle = phone || email || loginHandle;

        if (phone && email) {
            handle = window.innerHeight > window.innerWidth ? phone : email;
        }

        const { useEmail, showForgotPassword } = this.options;

        return {
            handle,
            useEmail,
            showForgotPassword,
        };
    },

    next(event) {
        event.preventDefault();

        this.$el.css({ "max-height": "1200px" });
        let handle = this.ui.handle.val().trim();
        if (!handle.length) {
            this.showError("This field is required");
            return;
        }

        const valid =
            handle.replace(/\D/g, "").length === 10 ||
            (handle.indexOf("@") > -1 && handle.indexOf(".") > -1);

        if (!valid) {
            heapTrack("Auth - Handle Invalid");
            this.showError("Please enter a valid email or phone number");
            return;
        }

        this.showError();

        const isEmail = handle.indexOf("@") > -1;
        if (isEmail) {
            this.model.set("email", handle);
            this.model.unset("phone");
        } else {
            handle = handle.replace(/\D/g, "");
            this.model.set("phone", handle);
            this.model.unset("email");
        }

        this.model.set("handle", handle);

        this.ui.nextBtn.loading(true);

        this.model.save(null, {
            success: () => {
                heapTrack("Auth - Handle Success", {
                    forgot: !!this.options.forgot,
                    authType: this.model.getAuthType(),
                    accountType: this.model.getAccountType(),
                    handleType: isEmail ? "email" : "phone",
                });
                this.trigger("success");
            },
            error: (model, response) => {
                const resp = response.responseText;
                let msg = "Sorry, an error occurred. Please try again";

                const csrfError = resp && resp.indexOf("CSRF") > -1;

                if (csrfError) {
                    msg =
                        "Sorry, the login form has gone idle. Please simply " +
                        "refresh the page and try again";
                } else if (response.status === 404) {
                    msg =
                        "We aren't finding an account with that " +
                        "info. Please try a different login.";
                }

                this.showError(msg);
                setTimeout(() => {
                    util.showLoginChat();
                }, 8000);

                heapTrack("Auth - Handle Error", {
                    csrfError,
                    forgot: !!this.options.forgot,
                    handleType: isEmail ? "email" : "phone",
                    status: response.status,
                });
            },
            complete: () => {
                this.ui.nextBtn.loading(false);
            },
        });
    },

    showError(msg) {
        this.ui.handle.toggleClass("has-error", !!msg);
        this.ui.error.text(msg || "");
    },
});

export default UserHandleComponent;
